import { FormikProps, FormikValues } from "formik";
import { useTranslation } from "next-i18next";
import React from "react";

import ActionButton from "../../../buttons/action-button";
import { KINDS, SIZES } from "../../../buttons/buttons.constants";
import { TYPES } from "../../../inputs/input.constants";
import { TextInput } from "../../../inputs/text-input/text-input";
import styles from "../forms.module.scss";

type Props = {
    formikProps: FormikProps<FormikValues>;
};

const RecipientDetailsForm: React.FC<Props> = ({
    formikProps: {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        submitForm,
    },
}) => {
    const { t } = useTranslation();
    return (
        <div>
            <form onSubmit={handleSubmit}>
                <TextInput
                    type={TYPES.TEXT}
                    label={t("giftCards.forms.buyForFriend.name")}
                    name="recipientName"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.recipientName}
                    touched={touched.recipientName}
                    errors={errors.recipientName}
                />

                <TextInput
                    label={t("giftCards.forms.buyForFriend.email")}
                    type={TYPES.EMAIL}
                    name="recipientEmail"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.recipientEmail}
                    touched={touched.recipientEmail && touched.recipientConfirmEmail}
                    errors={errors.recipientEmail}
                />

                <TextInput
                    label={t("giftCards.forms.buyForFriend.confirmEmail")}
                    type={TYPES.EMAIL}
                    name="recipientConfirmEmail"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.recipientConfirmEmail}
                    touched={touched.recipientConfirmEmail && touched.recipientEmail}
                    errors={errors.recipientConfirmEmail}
                />

                <TextInput
                    type={TYPES.TEXT}
                    label={t("giftCards.forms.buyForFriend.message")}
                    name="recipientMessage"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.recipientMessage}
                    touched={touched.recipientMessage}
                    errors={errors.recipientMessage}
                />

                <h2 className={styles.consumerHeader}>
                    {t("giftCards.forms.buyForYourself.header")}
                </h2>

                <TextInput
                    type={TYPES.TEXT}
                    label={t("giftCards.forms.buyForYourself.firstname")}
                    name="consumerFirstname"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.consumerFirstname}
                    touched={touched.consumerFirstname}
                    errors={errors.consumerFirstname}
                />

                <TextInput
                    type={TYPES.TEXT}
                    label={t("giftCards.forms.buyForYourself.lastname")}
                    name="consumerLastname"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.consumerLastname}
                    touched={touched.consumerLastname}
                    errors={errors.consumerLastname}
                />

                <TextInput
                    label={t("giftCards.forms.buyForYourself.email")}
                    type={TYPES.EMAIL}
                    name="consumerEmail"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.consumerEmail}
                    touched={touched.consumerEmail && touched.consumerConfirmEmail}
                    errors={errors.consumerEmail}
                />

                <TextInput
                    label={t("giftCards.forms.buyForYourself.confirmEmail")}
                    type={TYPES.EMAIL}
                    name="consumerConfirmEmail"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.consumerConfirmEmail}
                    touched={touched.consumerConfirmEmail && touched.consumerEmail}
                    errors={errors.consumerConfirmEmail}
                />

                <div className={styles.mobileConfirmButton}>
                    <ActionButton
                        disabled={isSubmitting}
                        fluid={true}
                        kind={KINDS.PRIMARY}
                        size={SIZES.LARGE}
                        label={t("giftCards.forms.submit")}
                        onClick={submitForm}
                    />
                </div>
            </form>
        </div>
    );
};

export default RecipientDetailsForm;
